import React from 'react';
import NavOne from './NavOne';
import TopOne from './TopOne';

const HeaderOne = () => {
    return(
        <>
        <header className="o-header">
            <TopOne />
            
            <NavOne />
        </header>
        </>
    )
}

export default HeaderOne;